import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useLanguage } from '../contexts/LanguageContext'
import { Button } from './ui/button'
import BrandLogo from './BrandLogo'
import LanguageToggle from './LanguageToggle'
import ThemeMenu from './ThemeMenu'
import { Magnetic } from './celebration'

// Shared header for the public marketing pages (Home, About).
const MarketingHeader = () => {
  const { user } = useAuth()
  const { language } = useLanguage()
  const navigate = useNavigate()
  const isKa = language === 'ka'

  // Mockup nav: transparent at the top, gains blur + violet shadow once scrolled.
  const [scrolled, setScrolled] = useState(false)
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const nav = [
    { to: '/', label: isKa ? 'მთავარი' : 'Home' },
    { to: '/templates', label: isKa ? 'შაბლონები' : 'Templates' },
    { to: '/about', label: isKa ? 'ჩვენ შესახებ' : 'About' },
  ]

  return (
    <header
      className={`sticky top-0 z-40 transition-[background-color,box-shadow] duration-300 motion-reduce:transition-none ${
        scrolled
          ? 'bg-[#fff7f2]/80 shadow-[0_6px_24px_rgba(109,40,217,0.08)] backdrop-blur-xl dark:bg-[#130b26]/80'
          : 'bg-transparent'
      }`}
    >
      <div
        className={`mx-auto flex max-w-6xl items-center justify-between px-5 transition-[padding] duration-300 motion-reduce:transition-none ${
          scrolled ? 'py-2.5' : 'py-3.5'
        }`}
      >
        <div className="flex items-center gap-7">
          <BrandLogo to="/" />
          <nav className="hidden items-center gap-6 md:flex">
            {nav.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                className="relative text-sm font-semibold text-[#4a3d66] transition-colors hover:text-[#1b1033] after:absolute after:-bottom-1.5 after:left-0 after:h-[3px] after:w-0 after:rounded-full after:bg-grad-hot after:transition-[width] after:duration-300 hover:after:w-full motion-reduce:after:transition-none dark:text-[#c3b8dd] dark:hover:text-white"
              >
                {n.label}
              </Link>
            ))}
          </nav>
        </div>
        <div className="flex items-center gap-2 sm:gap-3">
          <LanguageToggle />
          <ThemeMenu />
          <Magnetic>
            <Button
              onClick={() => navigate(user ? '/dashboard' : '/login')}
              className="h-10 rounded-full btn-gradient px-5 text-sm font-semibold text-white"
              data-testid="marketing-cta"
            >
              {user
                ? isKa
                  ? 'დაშბორდი'
                  : 'Dashboard'
                : isKa
                  ? 'შესვლა'
                  : 'Sign in'}
            </Button>
          </Magnetic>
        </div>
      </div>
    </header>
  )
}

export default MarketingHeader
